import React from "react"
import { AppToolbarCreateButton } from "@components"

import { useUserSettingsOfficesGroup } from "../@hooks"


export default function UserSettingOfficesGroupTabButton() {
    const { handleSetOfficesGroupFormData } = useUserSettingsOfficesGroup()

    return <AppToolbarCreateButton
        label="Define Offices Group"
        onClick={handleSetOfficesGroupFormData}
    />
}